import { RetailCentreWithScores } from "./retailCentre";

export class PinnedLocation {
    public readonly latitude: number;
    public readonly longitude: number;
    public readonly address: string;
    public readonly retailCentre: RetailCentreWithScores;
    public readonly placeCategoryId: number;
    public readonly secondaryPlaceCategoryIds: number[];

    constructor(
        latitude: number,
        longitude: number,
        address: string,
        retailCentre: RetailCentreWithScores,
        placeCategoryId: number = 58,
        secondaryPlaceCategoryIds: number[] = [81, 82]
    ) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.address = address;
        this.retailCentre = retailCentre;
        this.placeCategoryId = placeCategoryId;
        this.secondaryPlaceCategoryIds = secondaryPlaceCategoryIds;
    }
}
